import React, { useEffect, useState, useMemo } from "react";
// import { useTranslation } from "react-i18next";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";
// import produce from "immer";
import { fetcher } from "../../client";
import {
  deleteCopyright,
  createCopyright,
  updateCopyright,
} from "../../actions/copyright";

export function useDeleteCopyright(options = {}) {
  return useMutation((id) => fetcher(deleteCopyright(id)), {
    ...options,
    onError: (error) => {
      toast.error(`${error}`);
      console.log(error);
    },
  });
}
export function useCreateCopyright(options = {}) {
  return useMutation((payload) => fetcher(createCopyright(payload)), {
    ...options,
  });
}
export function useUpdateCopyright(options = {}) {
  return useMutation((payload) => fetcher(updateCopyright(payload)), {
    ...options,
  });
}
